import Masonry from'masonry-layout';

function masonry(){
	var grid = document.querySelector('.masonry-grid');
	
	if ( grid ){
		var msnry = new Masonry( grid, {
			itemSelector: '.masonry-grid-item',
		});
	}
}

export default function(){

	masonry();


	$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
		masonry();
	});

}